/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { CityVizComponent } from "./cityviz.jsx";

const CityVizComponentDisplay = () => {
    
    const contentZoneContext = useContext(ContentZoneContext);
    const component = contentZoneContext?.component;

    return (
        <>
            <h2>CityViz</h2>
            <CityVizComponent
                component={component}
            />
        </>
    );
};

CityVizComponentDisplay.displayName = "CityVizComponentDisplay";
export { CityVizComponentDisplay };

